// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__M-r2c","header":"styles_header__EzJi+","text_wrapper":"styles_text_wrapper__ToLJF","editor":"styles_editor__CN9Ra"};